import "babel-polyfill"
import searchList from 'informationSearchListEnter'

new Vue({
    render: h => h(searchList)
}).$mount('#searchList')



// WEBPACK FOOTER //
// ./src/views/information/searchList/searchList.js